import Carousel from "@/components/slider/Carousel";
import Link from "next/link";
import Image from "next/legacy/image";
import { fitIn } from "@/utils/imageHandler";
import { Megaphone } from "@phosphor-icons/react";

function CarouselReport({
  title,
  showMoreText,
  spaceBetween,
  showMoreLink,
  data,
  cardHeight,
  totalAmount,
  container,
}) {
  return (
    <Carousel
      title={title}
      showMoreLink={showMoreLink}
      spaceBetween={spaceBetween}
      container={container}
      totalAmount={totalAmount}
    >
      {data.map((item, index) => (
        <Link
          href={`/reports/${item.slug}`}
          key={`report-${item.uuid}`}
          className={`block relative aspect-[93/125] rounded-md overflow-hidden ${cardHeight ?? "h-full"
            }`}
        >
          <Image
            src={fitIn(item.cover_image_url, 600)}
            layout='fill'
            objectFit='cover'
            alt='Image'
          />
          {!!item.is_coming_soon && (
            <div className='absolute inline-flex space-x-1 py-1 tracking-tight items-center px-2 text-[11px] shadow leading-none font-medium rounded-full top-2 right-2 bg-gradient-to-tr from-yellow-1 to-red-1'>
              <Megaphone weight='bold' className='text-sm' />
              <span>Coming Soon</span>
            </div>
          )}
        </Link>
      ))}
    </Carousel>
  );
}
export default CarouselReport;
